import { ReactNode } from "react";

type MobileStatCardProps = {
  label: string;
  value: string;
  unit?: string;
  icon: ReactNode;
  iconBg: string;
  iconColor: string;
  /**
   * 2026-09-16 変更:Mobile Dashboard で KPI に意味のない「↗ 0.0%」を
   * 全削除したため、change は undefined 推奨。指定時は右上に増減 chip を表示。
   */
  change?: number;
};

/**
 * モバイル版 KPI カード
 * アイコン + ラベル + 値 + 単位を 1 枚に収める
 */
export const MobileStatCard = ({
  label,
  value,
  unit,
  change,
  icon,
  iconBg,
  iconColor,
}: MobileStatCardProps) => {
  return (
    <div className="mobile-stat-card">
      <div className="mobile-stat-card-header">
        <div className="mobile-stat-card-icon" style={{ background: iconBg, color: iconColor }}>
          {icon}
        </div>
        {typeof change === "number" ? (
          <span className={`mobile-stat-card-trend ${change >= 0 ? "up" : "down"}`}>
            {change >= 0 ? "↗" : "↘"} {Math.abs(change).toFixed(1)}%
          </span>
        ) : null}
      </div>
      <div className="mobile-stat-card-label">{label}</div>
      <div>
        <span className="mobile-stat-card-value">{value}</span>
        {unit && <span className="mobile-stat-card-unit">{unit}</span>}
      </div>
    </div>
  );
};
